import GenericCanceled from "../GenericCanceledExitRequests/GenericCanceledExitRequests";
import { ALL_EXIT_REQUESTS_REG, ALL_EXIT_REQUESTS_EXPORT } from "@API/APIRoutes";

function AllCanceledExitRequestsListing() {
  return <GenericCanceled API={ALL_EXIT_REQUESTS_REG} exportApi={ALL_EXIT_REQUESTS_EXPORT} title={"All Canceled Exit Requests"} />;
}

export default AllCanceledExitRequestsListing;
